<template>
  <div class="image-section">
    <el-empty v-if="images.length === 0" description="暂无图片"></el-empty>
    <div v-else class="image-list-container">
      <div class="image-list">
        <div v-for="(image, index) in images" :key="index" class="image-item">
          <el-image
            :src="image"
            :preview-src-list="images"
            fit="contain"
            class="image-content"
            @click="handleImageClick(index)"
          >
            <div slot="error" class="image-error">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageSection",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleImageClick(index) {
      console.log("点击了图片:", index);
    },
  },
};
</script>

<style scoped>
/* 父容器设置固定高度和滚动 */
.image-section {
  height: 500px; /* 确保父级有高度（或在父组件中设置） */
  /* background-color: aqua; */
}

.image-list-container {
  max-height: 480px; /* 设置滚动区域的最大高度 */
  overflow-y: auto; /* 垂直滚动 */
  padding: 10px;
}

/* 网格布局保持不变 */
.image-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.image-item {
  height: 240px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.image-item:hover {
  transform: translateY(-5px);
}

.image-content {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  font-size: 24px;
}

/* 自定义滚动条样式（可选） */
.image-list-container::-webkit-scrollbar {
  width: 8px;
}
.image-list-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
</style>